import {
    faCheckCircle,
    faTimesCircle,
    faExclamationCircle,
    faUserFriends
} from '@fortawesome/free-solid-svg-icons';

/**
 * Returns configuration for status badges
 */
export const getStatusBadge = (status) => {
    const statusValue = status === 'pending' ? 'pending_manager' : (status || 'pending_manager');
    const config = {
        pending_manager: { color: '#f59e0b', bg: '#fef0c7', icon: faExclamationCircle, label: 'Attente Chef' },
        pending_rh: { color: '#3b82f6', bg: '#dbeafe', icon: faUserFriends, label: 'Attente RH' },
        approved: { color: '#10b981', bg: '#d1fadf', icon: faCheckCircle, label: 'Validé' },
        rejected: { color: '#ef4444', bg: '#fee2e2', icon: faTimesCircle, label: 'Rejeté' }
    };
    return config[statusValue] || config.pending_manager;
};

/**
 * Checks if a date is a weekend
 */
export const isWeekend = (dateString) => {
    const date = new Date(dateString);
    const day = date.getDay();
    return day === 0 || day === 6;
};

/**
 * Returns color based on hours worked
 */
export const getHoursColor = (hours) => {
    if (hours > 10) return '#ef4444';
    if (hours > 8) return '#f59e0b';
    return '#10b981';
};

/**
 * Returns the ISO week number for a date
 */
export const getWeek = (date) => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    d.setDate(d.getDate() + 4 - (d.getDay() || 7));
    const yearStart = new Date(d.getFullYear(), 0, 1);
    return Math.ceil((((d - yearStart) / 86400000) + 1) / 7);
};

/**
 * Formats a date to YYYY-MM-DD in local time
 */
export const formatLocalDate = (date) => {
    if (!date) return "";
    const d = typeof date === 'string' ? new Date(date) : date;
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};
